class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');

    // Try to find inside component first, otherwise search globally
    this.predictiveSearchResults =
      this.querySelector("#predictive-search") ||
      document.querySelector("#predictive-search");

    if (!this.input) {
      console.warn("PredictiveSearch: No search input found.");
      return;
    }

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          this.close();
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const section = doc.querySelector("#shopify-section-predictive-search");

        if (section && this.predictiveSearchResults) {
          this.predictiveSearchResults.innerHTML = section.innerHTML;
          this.open();
        } else {
          this.close();
        }
      })
      .catch((error) => {
        console.error("PredictiveSearch error:", error);
        this.close();
      });
  }

  open() {
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.style.display = "block";
    }
  }

  close() {
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.style.display = "none";
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get("predictive-search")) {
  customElements.define("predictive-search", PredictiveSearch);
}
